module.exports = __webpack_public_path__ + "img/emo_26.8a474c37.png";